import { CAREERS } from "constants/routes";
import CareerPage from "./container/CareerPage";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";

export default function getSettingsRoute(userAuth) {
  const { account, cpfm } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [cpfm.name]: [cpfm.roles.admin],
  };
  return {
    path: CAREERS,
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    withSidebar: true,
    withAppBar: true,
    component: CareerPage,
  };
}
